module.exports = __webpack_public_path__ + "img/btn-back-black-record.b64e470e.png";